<div class="wrapper__body">
  <div class="wrapper__body__content">
    <div *ngIf="isLoading" class="spinner-container">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>

    <ng-container *ngIf="!isLoading">
      <div class="card-header">
        <h2 class="title">{{ customerName }}</h2>
      </div>

      <div class="wrapper__body__content__title">
        {{ 'sepa.sectionTitle' | translate }}
      </div>
      <p class="wrapper__body__content__subtitle">
        {{ 'sepa.sectionSubtitle' | translate }}
      </p>

      <form [formGroup]="form" (ngSubmit)="save()">
        <!-- IBAN -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.iban' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <input
                type="text"
                class="form-control md-input"
                formControlName="iban"
                [placeholder]="'sepa.ibanPlaceholder' | translate"
                [ngClass]="{ 'is-invalid': isFieldInvalid('iban') }"
              />
              <div
                *ngIf="isFieldInvalid('iban')"
                class="general-invalid-feedback"
              >
                {{ 'general.required' | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- BIC / SWIFT -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.bic' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <input
                type="text"
                class="form-control md-input"
                formControlName="bic"
                [placeholder]="'sepa.bicPlaceholder' | translate"
              />
            </div>
          </div>
        </div>

        <hr class="field-separator" />

        <!-- ID MANDATO -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.mandateId' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <input
                type="text"
                class="form-control md-input"
                formControlName="mandateId"
                [placeholder]="'sepa.mandateIdPlaceholder' | translate"
              />
            </div>
          </div>
        </div>

        <!-- FECHA FIRMA MANDATO -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.mandateSignatureDate' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <input
                type="date"
                class="form-control md-input"
                formControlName="mandateSignatureDate"
              />
            </div>
          </div>
        </div>

        <hr class="field-separator" />

        <!-- TIPO SECUENCIA -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.sequenceType' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <select
                class="form-control md-input"
                formControlName="sequenceType"
              >
                <option
                  *ngFor="let opt of sequenceTypeOptions"
                  [value]="opt.value"
                >
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- IMPORTE HABITUAL -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.usualAmount' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <input
                type="number"
                class="form-control md-input"
                formControlName="usualAmount"
                [placeholder]="'0.00 €'"
                min="0"
                step="0.01"
              />
              <div
                *ngIf="isFieldInvalid('usualAmount')"
                class="general-invalid-feedback"
              >
                {{ 'general.required' | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- DÍA DE COBRO -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.collectionDay' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <input
                type="number"
                class="form-control md-input"
                formControlName="collectionDay"
                placeholder="1-28"
                min="1"
                max="28"
              />
              <div
                *ngIf="isFieldInvalid('collectionDay')"
                class="general-invalid-feedback"
              >
                {{ 'general.required' | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- CONCEPTO BASE -->
        <div class="wrapper__body__content__field">
          <div class="wrapper__body__content__field__label">
            <label class="field-label">
              {{ 'sepa.baseConcept' | translate | uppercase }}
            </label>
          </div>
          <div class="wrapper__body__content__field__content">
            <div class="input__wrapper">
              <input
                type="text"
                class="form-control md-input"
                formControlName="baseConcept"
                [placeholder]="'sepa.baseConceptPlaceholder' | translate"
              />
            </div>
          </div>
        </div>

        <!-- GUARDAR -->
        <div class="wrapper__body__content__actions">
          <button
            type="submit"
            class="base-button base-button--primary"
            [disabled]="isSaving"
          >
            {{ 'general.save' | translate }}
          </button>
        </div>
      </form>
    </ng-container>
  </div>
</div>
